/* istanbul ignore file */
import { EventEmitter } from 'events';
import { getLabelById } from '../utilities/getLabelById';
import { DlpOverrideOptions } from '@fluidx/office-fluid-types';
export const mockDlpPolicyTipInfo = {
    generalText: 'This item contains information that violates Contoso company policy.',
    appliedActionsText: 'Access to this item is restricted for everyone except its creator, last modifier, and site owner.',
    complianceUrl: 'https://microsoft.com',
    overrideOptions: DlpOverrideOptions.AllowWithJustification,
    lastProcessedTime: Date.toString(),
    matchedConditionDescriptions: [
        `Item might contain the following sensitive information: Credit card number, driver's license number`,
        'Item might be shared with people outside your organization'
    ]
};
export const mockLabelSetSensitivityPayload = {
    id: '00000000-0000-0000-0000-00000000000z',
    assignmentMethod: 'privileged',
    justificationText: 'Justified',
    actionSource: 'manual'
};
export const mockProtectedLabelSetSensitivityPayload = {
    id: '00000000-0000-0000-0000-000000000000',
    assignmentMethod: 'privileged',
    justificationText: 'Justified',
    actionSource: 'manual'
};
export const mockAppliedSensitivityLabel = {
    sensitivityLabelId: '00000000-0000-0000-0000-000000000003',
    assignmentMethod: 'standard',
    tenantId: '00000000-0000-0000-0000-000000000000'
};
export const mockAppliedMostSensitiveLabel = {
    sensitivityLabelId: '00000000-0000-0000-0000-000000000000',
    assignmentMethod: 'standard',
    tenantId: '00000000-0000-0000-0000-000000000000'
};
export const mockWatermarking = {
    fontColor: '#000000',
    fontSize: 10,
    layout: 'diagonal',
    text: 'Watermark 10 Black Diagonal'
};
export const mockWatermarkingDiagonal = {
    fontColor: '#FFFF00',
    fontSize: 16,
    layout: 'diagonal',
    text: 'Watermark 16 Yellow Diagonal'
};
export const mockWatermarkHorizontal = {
    fontColor: '##00FF00',
    fontSize: 24,
    layout: 'horizontal',
    text: 'Watermark 24 Green Horizontal'
};
export const mockWatermarkingSmallFont = {
    fontColor: '#0000FF',
    fontSize: 10,
    layout: 'horizontal',
    text: 'Watermark 10 Blue Horizontal'
};
export const mockWatermarkingRedColor = {
    fontColor: '#FF0000',
    fontSize: 36,
    layout: 'diagonal',
    text: 'Watermark 36 Red Diagonal'
};
export const mockIrmCapabilities = {
    supportsCLP: true,
    canWrite: true,
    canExtract: true,
    canPrint: true
};
export const mockIrmCapabilitiesNoExtract = {
    supportsCLP: true,
    canWrite: true,
    canExtract: false,
    canPrint: true
};
export const mockIrmCapabilitiesNoPrint = {
    supportsCLP: true,
    canWrite: true,
    canExtract: true,
    canPrint: false
};
export const mockIrmCapabilitiesNoWrite = {
    supportsCLP: true,
    canWrite: false,
    canExtract: true,
    canPrint: true
};
export const mockIrmCapabilitiesAllFalse = {
    supportsCLP: true,
    canWrite: false,
    canExtract: false,
    canPrint: false
};
export const mockPolicySettings = {
    id: '00000000-0000-0000-0000-000000000003',
    moreInfoUrl: 'https://aka.ms/classification',
    isDowngradeJustificationRequired: true,
    isMandatory: false,
    defaultLabelId: '00000000-0000-0000-0000-000000000003'
};
export const mockSensitivityLabels = [
    {
        name: 'Low Sensitivity',
        isActive: true,
        id: '00000000-0000-0000-0000-00000000000z',
        sensitivity: 0,
        color: 'red',
        tooltip: 'This label does not set any restrictions on IRM capabilities, does not show a watermark, and is not protected.',
        description: 'Description',
        parent: null
    },
    {
        name: 'Most Sensitive',
        isActive: true,
        id: '00000000-0000-0000-0000-000000000000',
        sensitivity: 15,
        color: 'red',
        tooltip: 'This label tests a combination of the most restrictive settings including: hasProtection, IRM.canPrint false, IRM.canExtract false, and a Watermark.',
        description: 'Description',
        parent: null,
        hasProtection: true
    },
    {
        name: 'Watermark Testing Labels',
        isActive: true,
        id: '00000000-0000-0000-0000-000000000001',
        sensitivity: 3,
        color: 'red',
        tooltip: 'Set of labels to explicitly test different Watermarking styles.',
        description: 'Description',
        parent: null
    },
    {
        name: 'Alignment: Diagonal',
        isActive: true,
        id: '00000000-0000-0000-0000-000000000002',
        sensitivity: 3,
        color: 'red',
        tooltip: 'This label will display a watermark that is diagonally aligned.',
        description: 'Description',
        parent: {
            name: 'Watermark Testing Labels',
            isActive: true,
            id: '00000000-0000-0000-0000-000000000001',
            sensitivity: 3,
            color: 'red',
            tooltip: 'Set of labels to explicitly test different Watermarking styles.',
            description: 'Description',
            parent: null
        }
    },
    {
        name: 'Alignment: Horizontal',
        isActive: true,
        id: '00000000-0000-0000-0000-000000000003',
        sensitivity: 3,
        color: 'red',
        tooltip: 'This label will display a watermark that is aligned at 0 degrees like normal text.',
        description: 'Description',
        parent: {
            name: 'Watermark Testing Labels',
            isActive: true,
            id: '00000000-0000-0000-0000-000000000001',
            sensitivity: 3,
            color: 'red',
            tooltip: 'Set of labels to explicitly test different Watermarking styles.',
            description: 'Description',
            parent: null
        }
    },
    {
        name: 'Font Size: 16px',
        isActive: true,
        id: '00000000-0000-0000-0000-000000000004',
        sensitivity: 3,
        color: 'red',
        tooltip: 'This label will display a watermark that has 16px font size.',
        description: 'Description',
        parent: {
            name: 'Watermark Testing Labels',
            isActive: true,
            id: '00000000-0000-0000-0000-000000000001',
            sensitivity: 3,
            color: 'red',
            tooltip: 'Set of labels to explicitly test different Watermarking styles.',
            description: 'Description',
            parent: null
        }
    },
    {
        name: 'Color: Red',
        isActive: true,
        id: '00000000-0000-0000-0000-000000000005',
        sensitivity: 3,
        color: 'red',
        tooltip: 'This label will display a watermark with red font color.',
        description: 'Description',
        parent: {
            name: 'Watermark Testing Labels',
            isActive: true,
            id: '00000000-0000-0000-0000-000000000001',
            sensitivity: 3,
            color: 'red',
            tooltip: 'Set of labels to explicitly test different Watermarking styles.',
            description: 'Description',
            parent: null
        }
    },
    {
        name: 'IRM Testing Labels',
        isActive: true,
        id: '00000000-0000-0000-0000-00000000000e',
        sensitivity: 3,
        color: 'red',
        tooltip: 'Set of labels to explicitly test different IRM capabilities like printing and extracting data.',
        description: 'Description',
        parent: null
    },
    {
        name: 'Cannot Print',
        isActive: true,
        id: '00000000-0000-0000-0000-00000000000f',
        sensitivity: 3,
        color: 'red',
        tooltip: 'This label will disable printing by setting IRMCapabilities.canPrint to false.',
        description: 'Description',
        parent: {
            name: 'IRM Testing Labels',
            isActive: true,
            id: '00000000-0000-0000-0000-00000000000e',
            sensitivity: 3,
            color: 'red',
            tooltip: 'Set of labels to explicitly test different IRM capabilities like printing and extracting data.',
            description: 'Description',
            parent: null
        }
    },
    {
        name: 'Cannot Extract Data',
        isActive: true,
        id: '00000000-0000-0000-0000-00000000000g',
        sensitivity: 3,
        color: 'red',
        tooltip: 'This label will disable the extraction of data, like cut & copy, by setting IRMCapabilities.canExtract to false.',
        description: 'Description',
        parent: {
            name: 'IRM Testing Labels',
            isActive: true,
            id: '00000000-0000-0000-0000-00000000000e',
            sensitivity: 3,
            color: 'red',
            tooltip: 'Set of labels to explicitly test different IRM capabilities like printing and extracting data.',
            description: 'Description',
            parent: null
        }
    },
    {
        name: 'Cannot Write Data',
        isActive: true,
        id: '00000000-0000-0000-0000-00000000000i',
        sensitivity: 3,
        color: 'red',
        tooltip: 'This label will disable the writing of data by setting IRMCapabilities.canWrite to false.',
        description: 'Description',
        parent: {
            name: 'IRM Testing Labels',
            isActive: true,
            id: '00000000-0000-0000-0000-00000000000e',
            sensitivity: 3,
            color: 'red',
            tooltip: 'Set of labels to explicitly test different IRM capabilities like printing and extracting data.',
            description: 'Description',
            parent: null
        }
    },
    {
        name: 'Non-Active Label',
        isActive: false,
        id: '00000000-0000-0000-0000-00000000000h',
        sensitivity: 15,
        color: 'red',
        tooltip: '',
        description: 'This label should not show up in the Label picker UI because isActive is set to false.',
        parent: null
    }
];
export const mockGraphContenInfo = {
    metadata: [{ name: 'Name', value: 'value' }]
};
/* eslint-disable-next-line @typescript-eslint/no-explicit-any
-- TODO: Using 'any' type defeats the purpose of TypeScript. Consider replacing it with a concrete type, or 'unknown'. */
export const mockResolvedUrl = {
    type: 'fluid',
    url: 'mockResolvedUrl',
    id: '',
    tokens: {},
    endpoints: {},
    hashedDocumentId: 'docId',
    driveId: 'mockDriveId',
    itemId: 'mockItemId',
    siteUrl: 'https://mockSiteUrl.com'
};
export const mockInformationProtectionCache = {
    policySettings: mockPolicySettings,
    watermark: mockWatermarkingDiagonal,
    irmCapabilities: mockIrmCapabilitiesAllFalse,
    hasProtection: true
};
let mockInstance = undefined;
/**
 * Helper to return a singleton instance of the mock sharing service.
 * A singleton instance is helpful for adding spy implementations.
 * @returns the singleton mock information protection service
 */
export function getMockInformationProtectionService() {
    if (mockInstance) {
        return mockInstance;
    }
    mockInstance = new MockInformationProtectionService();
    return mockInstance;
}
export class MockInformationProtectionService extends EventEmitter {
    constructor() {
        super(...arguments);
        this.currentLabel = undefined;
    }
    get InformationProtectionService() {
        return this;
    }
    /**
     * Returns the currently applied sensitivity label information on the document for the user
     * @returns a promise with applied sensitivity label information
     */
    async getCurrentLabel(_resolvedUrl) {
        return this.currentLabel;
    }
    /**
     * Returns true if the currently applied sensitivity label enforces encryption of the document.
     * @returns a promise with boolean
     */
    async getHasProtection(_resolvedUrl) {
        if (this.currentLabel) {
            return !!getLabelById(mockSensitivityLabels, this.currentLabel.sensitivityLabelId)?.hasProtection;
        }
        return false;
    }
    /**
     * Gets the watermarking details (if applicable)
     * @returns a promise with watermarking information
     */
    async getWatermarkInformation(_resolvedUrl) {
        if (this.currentLabel) {
            return Promise.resolve(this.getMockWatermarkByLabelId(this.currentLabel.sensitivityLabelId));
        }
        return undefined;
    }
    /**
     * Returns the client capabilities supported by the document for the user
     * @returns a promise with client capabilities
     */
    async getIrmInformation(_resolvedUrl) {
        if (this.currentLabel) {
            return Promise.resolve(this.getMockIrmCapabilitiesByLabelId(this.currentLabel.sensitivityLabelId));
        }
        return mockIrmCapabilities;
    }
    /**
     * Retrieves the DLP policy tip that is shown as a banner message
     * @returns a promise with DLP policy tip information
     */
    async getDlpTooltip(_resolvedUrl) {
        this.emit('dlpPolicyTip', mockDlpPolicyTipInfo);
        return mockDlpPolicyTipInfo;
    }
    /**
     * Retrieves the policy settings for the user
     * @returns a promise with policy settings information
     */
    async getPolicySettings(_tenantId) {
        return mockPolicySettings;
    }
    /**
     * Gets a list of all configured information protection labels for the user
     * @returns a promise with the list of label information
     */
    async getLabels(_tenantId) {
        return mockSensitivityLabels;
    }
    /**
     * Overrides the  policy tip. This will override the policy set by the Data Loss Protection algorithm.
     * @param _override The new override information
     */
    async overrideDlpPolicyTip(_override) {
        return true;
    }
    /**
     * Sets the label information on the document for the user
     * @param _resolvedUrl
     * @param newLabel The new label information to be applied to the document
     */
    async setCurrentLabel(_resolvedUrl, newLabel) {
        this.currentLabel = { ...mockAppliedSensitivityLabel, sensitivityLabelId: newLabel.id };
        this.emit('sensitivityLabelChanged', this.currentLabel);
        this.emit('IrmCapabilitiesChanged', this.getMockIrmCapabilitiesByLabelId(newLabel.id));
        this.emit('watermarkingChanged', this.getMockWatermarkByLabelId(newLabel.id));
        return true;
    }
    async removeCurrentLabel(_resolvedUrl, _label) {
        this.currentLabel = undefined;
        this.emit('sensitivityLabelChanged', this.currentLabel);
        return true;
    }
    /**
     * Returns true if mandatory labeling is required
     * @returns a promise with boolean
     */
    async getIsMandatoryLabeling(_resolvedUrl) {
        return false;
    }
    /** @deprecated Implemented for backward compatibility */
    async getAppliedLabel() {
        return this.currentLabel;
    }
    /** @deprecated Implemented for backward compatibility */
    async getIsProtectionEnabled() {
        if (this.currentLabel) {
            return !!getLabelById(mockSensitivityLabels, this.currentLabel.sensitivityLabelId)?.hasProtection;
        }
        return false;
    }
    /** @deprecated Implemented for backward compatibility */
    async getWatermarking() {
        if (this.currentLabel) {
            return Promise.resolve(this.getMockWatermarkByLabelId(this.currentLabel.sensitivityLabelId));
        }
        return mockWatermarking;
    }
    /** @deprecated Implemented for backward compatibility */
    async getIrmCapabilities() {
        if (this.currentLabel) {
            return Promise.resolve(this.getMockIrmCapabilitiesByLabelId(this.currentLabel.sensitivityLabelId));
        }
        return mockIrmCapabilities;
    }
    /** @deprecated Implemented for backward compatibility */
    async getDlpPolicyTip() {
        this.emit('dlpPolicyTip', mockDlpPolicyTipInfo);
        return mockDlpPolicyTipInfo;
    }
    /**
     * Trigger mandatory label policy experience as appropriate
     */
    enforceMandatoryLabelExperience(_resolvedUrl) { }
    /** @deprecated Implemented for backward compatibility */
    async setLabel(newLabel) {
        this.currentLabel = { ...mockAppliedSensitivityLabel, sensitivityLabelId: newLabel.id };
        return true;
    }
    /** @deprecated Implemented for backward compatibility */
    async removeLabel(_label) {
        this.currentLabel = undefined;
        return true;
    }
    getMockIrmCapabilitiesByLabelId(id) {
        switch (id) {
            // Most Sensitive
            case '00000000-0000-0000-0000-000000000000':
                return mockIrmCapabilitiesAllFalse;
            // IRM Testing Labels - Cannot Print
            case '00000000-0000-0000-0000-00000000000f':
                return mockIrmCapabilitiesNoPrint;
            // IRM Testing Labels - Cannot Extract Data
            case '00000000-0000-0000-0000-00000000000g':
                return mockIrmCapabilitiesNoExtract;
            // IRM Testing Labels - Cannot Write Data
            case '00000000-0000-0000-0000-00000000000i':
                return mockIrmCapabilitiesNoWrite;
            default:
                return mockIrmCapabilities;
        }
    }
    getMockWatermarkByLabelId(id) {
        switch (id) {
            // Watermark Testing Labels - Alignment: Diagonal
            case '00000000-0000-0000-0000-000000000002':
                return mockWatermarkingDiagonal;
            // Watermark Testing Labels - Alignment: Horizontal
            case '00000000-0000-0000-0000-000000000003':
                return mockWatermarkHorizontal;
            // Watermark Testing Labels - Font Size: 10px
            case '00000000-0000-0000-0000-000000000004':
                return mockWatermarkingSmallFont;
            // Watermark Testing Labels - Color: Red
            case '00000000-0000-0000-0000-000000000005':
                return mockWatermarkingRedColor;
            // Low Sensitivity
            case '00000000-0000-0000-0000-00000000000z':
                return undefined;
            default:
                return mockWatermarking;
        }
    }
}
//# sourceMappingURL=MockInformationProtectionService.js.map